import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  envName: 'development',
  apiBaseUrl: 'https://idptenantapi.katdev.com/api',
  tenantId: undefined,
};
